/**
 * Extracts "Cal Notes" from an array of client note objects.
 * Cal Notes are text segments bookended by double asterisks: **note text**
 *
 * @param {Array} notesArr - Array of note objects with a `note` string field
 * @returns {Array<string>} - Extracted cal note strings, each prefixed with "- "
 */
const CAL_NOTE_REGEX = /(?<=\*\*)([ \t]?\w{1}[\w\W\s]*?)(?=\*{2})/gm;

export function extractCalNotes(notesArr) {
  if (!notesArr || !Array.isArray(notesArr) || notesArr.length === 0) {
    return [];
  }

  const calNotes = [];

  for (const noteObj of notesArr) {
    const noteText = noteObj?.note || noteObj;
    if (typeof noteText !== "string") continue;

    const matches = noteText.match(CAL_NOTE_REGEX);
    if (matches && matches.length > 0) {
      for (const match of matches) {
        const trimmed = match.trim();
        if (trimmed) {
          calNotes.push(`- ${trimmed}`);
        }
      }
    }
  }

  return calNotes;
}
